import { Component, OnInit } from '@angular/core';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {EditService} from '../shared/services/editService/edit.service';
import {FormItem} from '../shared/classes/FormItem';
import {FormItemsService} from '../shared/services/databaseServices/formItems/form-items.service';
import {Router} from '@angular/router';
import {TranslatePipe} from '../translate.pipe';

@Component({
  selector: 'app-form-items',
  templateUrl: './form-items.component.html',
  styleUrls: ['./form-items.component.css'],
  providers: [TranslatePipe]
})
export class FormItemsComponent implements OnInit {

  displayedColumns: string[] = ['visibleText', 'type', 'visibleDefault', 'requiredDefault'];

  header = [
    {
      defName: 'visibleText',
      translation: 'settingPage.formItems.tab.visibleText',
      elem: 'visibleText'
    },
    {
      defName: 'type',
      translation: 'settingPage.formItems.tab.type',
      elem: 'type'
    },
    {
      defName: 'visibleDefault',
      translation: 'settingPage.formItems.tab.visibleDefault',
      elem: 'visibleDefault'
    },
    {
      defName: 'requiredDefault',
      translation: 'settingPage.formItems.tab.requiredDefault',
      elem: 'requiredDefault'
    }
  ];

  faPlus = faPlus;
  formItems: FormItem[] = undefined;

  constructor(private editService: EditService,
              private formItemsService: FormItemsService,
              private router: Router,
              private translate: TranslatePipe) { }

  ngOnInit() {
    this.formItemsService.getFormItems().then( data => {
      this.formItems = [];
      data.forEach( item => {
        const formItem = new FormItem();
        formItem.key = item.id;
        formItem.required = item.data().required;
        formItem.requiredDefault = item.data().requiredDefault;
        formItem.type = item.data().type;
        formItem.visible = item.data().visible;
        formItem.visibleDefault = item.data().visibleDefault;
        formItem.visibleText = this.translate.transform(`settingPage.formBuilder.formBuilder.item.${item.data().visibleText}`);
        this.formItems.push(formItem);
      });
      this.formItems = this.formItems.map( formItem => {
        formItem.type.get().then( type => {
          formItem.type = type.data().type;
          return formItem;
        });
        return formItem;
      });

    });
  }

  create() {
    this.router.navigate(['/admin/settings/formItems', 'new']);
  }

  isEdit(){
    return this.editService.editable;
  }

  edit(item){
    this.router.navigate(['/admin/settings/formItems', item.key]);
  }

}
